function isPlainObject(value) {
    return typeof value === 'object'
        && value !== null
        && value.constructor === Object
        && Object.prototype.toString.call(value) === '[object Object]';
}

function isArray(value) {
    return Array.isArray(value);
}

function isFunction(value) {
    return typeof value === 'function';
}

function isArrayOrObject(value) {
    return isPlainObject(value) || isArray(value);
}

function isEqual(lhs, rhs) {
    if (!lhs || !rhs) {
        return false;
    }

    if (!isPlainObject(lhs) || !isPlainObject(rhs)) {
        return lhs === rhs;
    }

    if (Object.keys(lhs).length !== Object.keys(rhs).length) {
        return false;
    }

    for (const [key, value] of Object.entries(lhs)) {
        // eslint-disable-next-line no-prototype-builtins
        if (!rhs.hasOwnProperty(key)) {
            return false;
        }

        const rightValue = rhs[key];

        if (isArrayOrObject(value) && isArrayOrObject(rightValue)) {

            if (isPlainObject(value) && isPlainObject(rightValue)) {
                if (isEqual(value, rightValue)) {
                    continue;
                }

                return false;
            } else if (isArray(value) && isArray(rightValue)) {
                if (isEqual(value, rightValue)) {
                    continue;
                }

                return false;
            } else {

                return false;
            }
        }

        if (isFunction(value) && isFunction(rightValue)) {
            if (value.toString() === rightValue.toString()) {
                continue;
            }

            return false;
        }

        if (value !== rightValue) {
            if (Number.isNaN(value) && Number.isNaN(rightValue)) {
                continue;
            }

            return false;
        }
    }

    return true;
}

function getNoun(number, one, two, five) {
    let n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
        return five;
    }
    n %= 10;
    if (n === 1) {
        return one;
    }
    if (n >= 2 && n <= 4) {
        return two;
    }
    return five;
}

export {isArray, isArrayOrObject, isPlainObject, isFunction, isEqual, getNoun};
